import(/* webpackMode: "eager", webpackExports: ["AuthorPage"] */ "/app/src/views/client/AuthorPage/AuthorPage.tsx");
